import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('pulling_from_connected_organisation'),
    subtitle: defineMessage('what_is_to_happen_if_ap_workflow_in_approvalmax_3'),
    optionDoNotPull: defineMessage('do_not_pull_this_document_to_approvalmax'),
    optionPull: defineMessage('pull_this_document_to_approvalmax'),
    dateDescription: defineMessage('select_from_which_date__approvalmax_as_approved'),
    datePlaceholder: defineMessage('pick_the_date'),
};
